var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import { DatagridConfigurable, List, TextField, TextInput, useRecordContext, useDelete, WrapperField, FunctionField, useRefresh, useNotify, } from "react-admin";
import { ListActions } from "../../components/ListActions";
import { Box, Button, Drawer, Typography } from "@mui/material";
import { Dialog, IconButton } from "@sequentech/ui-essentials";
import { ActionsColumn } from "../../components/ActionButons";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import { useTenantStore } from "../../providers/TenantContextProvider";
import { useParams } from "react-router";
import { AreaContestItems } from "@/components/AreaContestItems";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { IPermissions } from "@/types/keycloak";
import { ImportDataDrawer } from "@/components/election-event/import-data/ImportDataDrawer";
import { useMutation } from "@apollo/client";
import { IMPORT_AREAS } from "@/queries/ImportAreas";
import styled from "@emotion/styled";
import { UPSERT_AREAS } from "@/queries/UpsertAreas";
import { ResetFilters } from "@/components/ResetFilters";
import { useAreaPermissions } from "./useAreaPermissions";
import { UpsertArea } from "./UpsertArea";
var ActionsBox = styled(Box)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n"], ["\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n"])));
var OMIT_FIELDS = ["id", "ballot_eml"];
var Filters = [
    _jsx(TextInput, { label: "Name", source: "name" }, 0),
    _jsx(TextInput, { label: "Description", source: "description" }, 1),
    _jsx(TextInput, { label: "ID", source: "id" }, 2),
    _jsx(TextInput, { label: "Type", source: "type" }, 3),
];
export var ListArea = function (props) {
    var t = useTranslation().t;
    var id = useParams().id;
    var refresh = useRefresh();
    var record = useRecordContext();
    var notify = useNotify();
    var tenantId = useTenantStore()[0];
    var deleteOne = useDelete()[0];
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState(false), openCreate = _b[0], setOpenCreate = _b[1];
    var _c = useState(false), openDeleteModal = _c[0], setOpenDeleteModal = _c[1];
    var _d = useState(), deleteId = _d[0], setDeleteId = _d[1];
    var _e = useState(false), openDrawer = _e[0], setOpenDrawer = _e[1];
    var _f = useState(undefined), recordId = _f[0], setRecordId = _f[1];
    var _g = useState(false), openImportDrawer = _g[0], setOpenImportDrawer = _g[1];
    var _h = useState(false), openUpsertDrawer = _h[0], setOpenUpsertDrawer = _h[1];
    var _j = useAreaPermissions(), canCreateArea = _j.canCreateArea, canEditArea = _j.canEditArea, canReadArea = _j.canReadArea, canDeleteArea = _j.canDeleteArea, canImportArea = _j.canImportArea, canExportArea = _j.canExportArea, canUpsertArea = _j.canUpsertArea, showAreaColumns = _j.showAreaColumns, showAreaFilters = _j.showAreaFilters;
    var importAreas = useMutation(IMPORT_AREAS, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.AREA_IMPORT,
            },
        },
    })[0];
    var upsertAreas = useMutation(UPSERT_AREAS, {
        context: {
            headers: {
                "x-hasura-role": IPermissions.AREA_UPSERT,
            },
        },
    })[0];
    // const authContext = useContext(AuthContext)
    // const canView = authContext.isAuthorized(true, tenantId, IPermissions.AREA_READ)
    // const canCreate = authContext.isAuthorized(true, tenantId, IPermissions.AREA_WRITE)
    useEffect(function () {
        if (recordId) {
            setOpen(true);
        }
    }, [recordId]);
    var createAction = function () {
        setOpenCreate(true);
    };
    var Empty = function () { return (_jsxs(ResourceListStyles.EmptyBox, { children: [_jsx(Typography, __assign({ variant: "h4", paragraph: true }, { children: t("areas.empty.header") })), canCreateArea && (_jsxs(_Fragment, { children: [_jsxs(ActionsBox, { children: [_jsxs(Button, __assign({ onClick: createAction, className: "area-add-button" }, { children: [_jsx(IconButton, { icon: faPlus, fontSize: "24px" }), t("areas.empty.action")] })), _jsxs(Button, __assign({ onClick: function () { return setOpenImportDrawer(true); } }, { children: [_jsx(IconButton, { icon: faPlus, fontSize: "24px" }), t("common.label.import")] }))] }), _jsx(Typography, __assign({ variant: "body1", paragraph: true }, { children: t("common.resources.noResult.askCreate") }))] }))] })); };
    var handleCloseCreateDrawer = function () {
        setRecordId(undefined);
        setOpenCreate(false);
        setOpenDrawer(false);
    };
    var handleCloseEditDrawer = function () {
        setOpen(false);
        setTimeout(function () {
            setRecordId(undefined);
        }, 400);
    };
    var editAction = function (id) {
        setRecordId(id);
    };
    var deleteAction = function (id) {
        // deleteOne("sequent_backend_area", {id})
        setOpenDeleteModal(true);
        setDeleteId(id);
    };
    var confirmDeleteAction = function () {
        deleteOne("sequent_backend_area", { id: deleteId }, {
            onSuccess: function () {
                refresh();
            },
            onError: function () {
                notify(t("areas.common.deleteError"), { type: "error" });
                refresh();
            },
        });
        setDeleteId(undefined);
    };
    var handleImportAreas = function (documentId, sha256) { return __awaiter(void 0, void 0, void 0, function () {
        var errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, importAreas({
                        variables: {
                            documentId: documentId,
                            electionEventId: record.id,
                            sha256: sha256,
                        },
                    })];
                case 1:
                    errors = (_a.sent()).errors;
                    refresh();
                    if (!errors) {
                        notify(t("electionEventScreen.importAreas.importSuccess"), { type: "success" });
                    }
                    else {
                        notify(t("electionEventScreen.importAreas.importError"), { type: "error" });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleUpsertAreas = function (documentId, sha256) { return __awaiter(void 0, void 0, void 0, function () {
        var errors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, upsertAreas({
                        variables: {
                            documentId: documentId,
                            electionEventId: record.id,
                        },
                    })];
                case 1:
                    errors = (_a.sent()).errors;
                    refresh();
                    if (!errors) {
                        notify(t("electionEventScreen.importAreas.importSuccess"), { type: "success" });
                    }
                    else {
                        notify(t("electionEventScreen.importAreas.importError"), { type: "error" });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var actions = [
        {
            icon: _jsx(EditIcon, { className: "edit-area-icon" }),
            action: editAction,
            showAction: function () { return canEditArea; },
        },
        {
            icon: _jsx(DeleteIcon, { className: "delete-area-icon" }),
            action: deleteAction,
            showAction: function () { return canDeleteArea; },
        },
    ];
    // check if data array is empty
    //const {data, isLoading} = listContext
    if (!canReadArea) {
        return _jsx(Empty, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(_Fragment, { children: _jsxs(List, __assign({ resource: "sequent_backend_area", actions: _jsx(ListActions, { withColumns: showAreaColumns, withFilter: showAreaFilters, withImport: canImportArea, doImport: function () { return setOpenImportDrawer(true); }, withExport: false, open: openDrawer, setOpen: setOpenDrawer, Component: _jsx(UpsertArea, { record: record, electionEventId: id, close: handleCloseCreateDrawer }), withComponent: canCreateArea, extraActions: [
                            canUpsertArea ? (_jsx(Button, __assign({ onClick: function () { return setOpenUpsertDrawer(true); } }, { children: t("electionEventScreen.importAreas.upsert") }), "upsert")) : (_jsx(_Fragment, {})),
                        ] }), empty: _jsx(Empty, {}), sx: { flexGrow: 2 }, storeKey: false, filters: Filters, filter: {
                        tenant_id: tenantId || undefined,
                        election_event_id: (record === null || record === void 0 ? void 0 : record.id) || undefined,
                    }, filterDefaultValues: {}, disableSyncWithLocation: true }, { children: [_jsx(ResetFilters, {}), _jsxs(DatagridConfigurable, __assign({ omit: OMIT_FIELDS }, { children: [_jsx(TextField, { source: "id" }), _jsx(TextField, { source: "name", className: "area-name" }), _jsx(TextField, { source: "description", className: "area-description" }), _jsx(FunctionField, { label: t("areas.sequent_backend_area_contest"), render: function (record) { return _jsx(AreaContestItems, { record: record }); } }), _jsx(WrapperField, __assign({ source: "actions", label: "Actions" }, { children: _jsx(ActionsColumn, { actions: actions }) }))] }))] })) }), _jsx(Drawer, __assign({ anchor: "right", open: open, onClose: handleCloseEditDrawer, PaperProps: {
                    sx: { width: "40%" },
                } }, { children: _jsx(UpsertArea, { id: recordId, electionEventId: id, close: handleCloseEditDrawer }) })), _jsx(Drawer, __assign({ anchor: "right", open: openCreate, onClose: handleCloseCreateDrawer, PaperProps: {
                    sx: { width: "40%" },
                } }, { children: _jsx(UpsertArea, { record: record, electionEventId: id, close: handleCloseCreateDrawer }) })), _jsx(Dialog, __assign({ variant: "warning", open: openDeleteModal, ok: t("common.label.delete"), cancel: t("common.label.cancel"), title: t("common.label.warning"), handleClose: function (result) {
                    if (result) {
                        confirmDeleteAction();
                    }
                    setOpenDeleteModal(false);
                } }, { children: t("common.message.delete") })), _jsx(ImportDataDrawer, { open: openImportDrawer, closeDrawer: function () { return setOpenImportDrawer(false); }, title: "electionEventScreen.importAreas.title", subtitle: "electionEventScreen.importAreas.subtitle", paragraph: "electionEventScreen.importAreas.areaParagraph", doImport: handleImportAreas, errors: null }), _jsx(ImportDataDrawer, { open: openUpsertDrawer, closeDrawer: function () { return setOpenUpsertDrawer(false); }, title: "electionEventScreen.importAreas.title", subtitle: "electionEventScreen.importAreas.subtitle", paragraph: "electionEventScreen.importAreas.areaParagraph", doImport: handleUpsertAreas, errors: null })] }));
};
var templateObject_1;
